null


// WEBPACK FOOTER //
// https://raw.githubusercontent.com/scala-js/scala-js/v0.6.25/library/src/main/scala/scala/scalajs/concurrent/QueueExecutionContext.scala